import MockRead from './MockRead'

export default MockRead